import API from "../../apiConfig";

export const fetchInventory = async (data) => {
  const response = await API.get("white_orange/v1/inventory", { params: data });
  return response;
};

export const fetchBrands = async (data) => {
  const response = await API.get("products/v1/brands", { params: data });
  return response;
};

export const fetchCategory = async () => {
  const response = await API.get("products/v1/categories?level=L1");
  return response;
};

export const updateInventory = async (data) => {
  const response = await API.post("white_orange/v1/updateInventory", data);
  return response;
};

export const searchModelId = async (data) => {
  const response = await API.get("products/v1/searchByModel", { params: data });
  return response;
};

export const fetchInventoryRequest = async (data) => {
  const response = await API.get("white_orange/v1/inventoryRequest", {
    params: data,
  });
  return response;
};

export const addInventoryRequest = async (data) => {
  const response = await API.post(
    "white_orange/v1/manageInventoryRequest",
    data
  );
  return response;
};

export const updatePrices = async (data) => {
  const response = await API.post("white_orange/v1/bulkUpdateInventory", data);
  return response;
};
